export default __webpack_public_path__ + "static/media/indonesian.96a31c72.svg";